import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "collect",
  "use": "collect-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"collect\"><path d=\"M11.83 2.114a.748.748 0 0 1 .566.093l3.145 4.92 5.346 1.315a.748.748 0 0 1 .549.908l-3.707 4.512.4 5.49a.748.748 0 0 1-.693.803L12 18.025l-5.099 2.077a.748.748 0 0 1-.977-.412l.347-5.828-3.552-4.208a.748.748 0 0 1 .09-1.056l5.65-1.472 2.904-4.677a.748.748 0 0 1 .466-.335z\" stroke=\"#6D7E93\" stroke-width=\"1.5\" fill=\"none\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol